module.exports = __webpack_public_path__ + "static/img/aboutUs_email.b95c838.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs_email.png
// module id = 7Z9g
// module chunks = 1